import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import qs from 'qs';
import NotificationSystem from 'react-notification-system';
import bn from '../../../utils/bemnames';
import { history } from '../../../utils/navigation-util';
import pathConst, { COMPANY_LOGO_PATH, MY_ALERT_INBOX, COMPANY_OVERVIEW } from '../../../constants/PathsConstant';
import { ALERT_NOTIFICATION_SYSTEM_STYLE } from '../../../utils/notificationStyle';
import { getPDF, getPDFLambda, getPDFOld, getPdfStatus } from '../../../utils/pdf-util';
import { dateToNull } from '../../../utils/general-util';
import { useFeatureToggle } from '../../../features/v2/FeatureToggles/hooks';
import { useStewardshipPdfDownload } from '../../../hooks/stewardship/useStewardshipPdfDownload';
import api from '../../../api';
import { useSelector } from 'react-redux';

const bem = bn.create('title');

/** @type {import('../../../utils/pdf-util').PdfStatus} */
const initialPdfStatus = { status: 'idle', id: 0, pdfPath: '' };

const TitleComponent = ({
  title,
  breadcrumbs = [],
  headers,
  pdfDownloadNotification,
  handlePDFDownloadNotification = () => {},
  generatePDF,
  handleGeneratePDF = () => {},
  handleVisitorLog = () => {},
  pdfListItems = [],
  InvestorTitle,
  company_logo = null,
  handlePDFDownloadCancelClick,
  pdfDownloadCancelBtn,
  notificationDataPopup,
  updateAlertStatusReq,
  getElementDetailReq,
  handleOnClickNotification,
  getInboxAlertByUserReq,
  handlePDFDownloadLoader = () => {},
  pdfDownloadLoader,
  pdfDownloadStartNotification,
  handleResetpdfDownloadStartNotification,
  middleContentComponent,
}) => {
  const [confirmPDFTitle, setConfirmPDFTitle] = useState('');
  const [pdfV2Status, setPdfV2Status] = useState(initialPdfStatus);
  const pdfId = useRef(null);
  const getStatusInterval = useRef(null);
  const notifiedStewardshipPdfRef = useRef({ state: null, path: null });
  const {
    pdfState: stewardshipPdfState,
    pdfError: stewardshipPdfError,
    pdfPath: stewardshipPdfPath,
    download: downloadStewardshipPdf,
  } = useStewardshipPdfDownload();
  const query = qs.parse(history.location.search, { ignoreQueryPrefix: true });
  const features = useFeatureToggle();
  const selectLatestOwnershipLabel = useSelector((state) => state.company.setValue_latestOwnershipDate.value);
  const selectChangeCompersationLabel = useSelector((state) => state.company.setValue_changeComparisionMonth.value);
  const meetingId = useSelector((state) => state.headerTitle.meetingid);
  const selectedCompanySearchId = useSelector((state) => state.tools.invCompCompanyPeerGroupSelection?.value);
  const selectedCompanySelection = useSelector((state) => state.dashboard.companySelection);
  const selectedCompanyPeerGroupSelection = useSelector((state) => state.tools.invCompCompanyPeerGroupSelection?.label);

  const notificationSystem = React.createRef();

  function xScrollIntoView(id, number) {
    setTimeout(() => {
      if (document.getElementById(id) !== null) {
        document.getElementById(id).scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    }, number);
  }

  const MAX_PDF_STATUS_ATTEMPTS = 36;
  const pdfStatusAttempts = useRef(0);

  useEffect(() => {
    if (pdfV2Status.status === 'pending' && !getStatusInterval.current) {
      pdfStatusAttempts.current = 0; // reset attempts
      getStatusInterval.current = setInterval(async () => {
        pdfStatusAttempts.current += 1;
        const pdfStatus = await getPdfStatus(pdfId.current);
        setPdfV2Status(pdfStatus);

        if (
          pdfStatus.status === 'success' ||
          pdfStatus.status === 'error' ||
          pdfStatusAttempts.current >= MAX_PDF_STATUS_ATTEMPTS
        ) {
          clearInterval(getStatusInterval.current);
          getStatusInterval.current = null;
          if (pdfStatusAttempts.current >= MAX_PDF_STATUS_ATTEMPTS && pdfStatus.status === 'pending') {
            setPdfV2Status({ ...pdfStatus, status: 'error' });
          }
        }
      }, 10000);
    } else if (pdfV2Status.status === 'success' || pdfV2Status.status === 'error') {
      clearInterval(getStatusInterval.current);
      getStatusInterval.current = null;
    }

    if (pdfV2Status.status === 'success') {
      setConfirmPDFTitle(title.replaceAll('System (', 'System-('));
      handleGeneratePDF({
        pdfstatus: true,
        pdffileURL: pdfV2Status.pdfPath,
        error: '',
      });
      handlePDFDownloadNotification(true);
      handlePDFDownloadCancelClick(false);
      handlePDFDownloadLoader(false);
    }

    let errorMessage = 'Error while sending PDF request!';
    if (pdfV2Status.status === 'error' && pdfStatusAttempts.current >= MAX_PDF_STATUS_ATTEMPTS) {
      errorMessage = 'PDF generation timed out after multiple attempts.';
    }
    if (pdfV2Status.status === 'error') {
      handleGeneratePDF({
        pdfstatus: false,
        pdffileURL: '',
        error: [errorMessage],
      });
      handlePDFDownloadNotification(true);
      handlePDFDownloadCancelClick(false);
      handlePDFDownloadLoader(false);
    }
  }, [pdfV2Status]);

  useEffect(() => {
    const notification = notificationSystem.current;
    if (notification === null) {
      return;
    }

    const alreadyNotified =
      notifiedStewardshipPdfRef.current.state === stewardshipPdfState &&
      notifiedStewardshipPdfRef.current.path === stewardshipPdfPath;
    if (alreadyNotified) {
      return;
    }
    notifiedStewardshipPdfRef.current = { state: stewardshipPdfState, path: stewardshipPdfPath };

    if (stewardshipPdfState === 'pending') {
      notification.addNotification({
        level: 'info',
        position: 'br',
        autoDismiss: 10,
        dismissible: true,
        children: (
          <>
            <div className="notifications-wrapper fadeInAnimation">
              <div className="notifications-{position}">
                <div className="alert-notificaitons">
                  <p className="alert-notification-title m-0">Stewardship Report Generation In Progress</p>
                </div>
              </div>
            </div>
          </>
        ),
      });
    } else if (stewardshipPdfState === 'success') {
      notification.addNotification({
        level: 'info',
        position: 'br',
        autoDismiss: null,
        dismissible: true,
        children: (
          <div className="pdfBorder">
            <div className="notifications-wrapper fadeInAnimation">
              <div className="notifications-{position}">
                <div
                  className="alert-notificaitons"
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      if (stewardshipPdfPath) {
                        window.open(stewardshipPdfPath, '_blank', 'noopener,noreferrer');
                      }
                    }
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    if (stewardshipPdfPath) {
                      window.open(stewardshipPdfPath, '_blank', 'noopener,noreferrer');
                    }
                  }}
                >
                  <div className="alert-notification-title">
                    <span className="">
                      <b>
                        Stewardship Report Complete <br />
                      </b>
                    </span>
                  </div>
                  <div className="d-flex align-items-center pdf-notify-link ">
                    <div>
                      Click&nbsp;
                      <span className="text-white link-alert" rel="noopener noreferrer">
                        <u>here</u>
                      </span>
                      &nbsp; to download.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ),
      });
    } else if (stewardshipPdfState === 'error') {
      notification.addNotification({
        level: 'error',
        position: 'br',
        dismissible: true,
        children: (
          <>
            <div className="notifications-wrapper fadeInAnimation">
              <div className="notifications-{position}">
                <div className="alert-notificaitons">
                  <div className="alert-notification-title">
                    <span className="">
                      <b>
                        Stewardship Report Error : {stewardshipPdfError || 'There was an issue generating the report'}{' '}
                        <br />
                      </b>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="notification-progressBar error" />
          </>
        ),
      });
    }
  }, [stewardshipPdfState, stewardshipPdfPath, stewardshipPdfError]);

  // #region generate PDF
  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const cancelToken = new AbortController();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    async function htmlToPdfFn() {
      let pdfstatus;

      const stewardshipItem = pdfListItems.find((p) => p.module === 'stewardship');
      const nonStewardshipItems = pdfListItems.filter((p) => p.module !== 'stewardship');

      if (stewardshipItem?.checked && !stewardshipItem?.disabled) {
        downloadStewardshipPdf(Number(query.pid), Number(stewardshipItem.stewardshipMeetingId), timeZone);
      }

      if (!nonStewardshipItems.some((p) => p.checked && !p.disabled)) {
        handlePDFDownloadLoader(false);
        return;
      }

      const onlyV2Requested =
        features.IS_PDF_V2 ||
        nonStewardshipItems.filter((p) => p.checked && !p.disabled).every((p) => p.version === 'v2');

      let isPdfV2On = true;
      if (onlyV2Requested) {
        try {
          const response = await api.get('/api/v2/pdf/isPdfV2Enabled');
          if (!response || (response.status && response.status !== 200)) {
            isPdfV2On = false;
          } else {
            isPdfV2On = response.data;
          }
        } catch (e) {
          isPdfV2On = false;
        }
      }

      if (onlyV2Requested && isPdfV2On === true) {
        if (nonStewardshipItems.filter((p) => !p.disabled).length > 0) {
          const documents = nonStewardshipItems.filter((p) => p.checked && !p.disabled).map((p) => p.v2Code);
          getPDFLambda(documents, query.pid, window.origin, timeZone, {
            latestOwnership: selectLatestOwnershipLabel,
            changeCompensation: selectChangeCompersationLabel,
            meetingId: Number(meetingId),
            companySearchId: selectedCompanySearchId,
            companySelection: selectedCompanySelection.map((i) => i.label),
            companyPeerGroupSelection: selectedCompanyPeerGroupSelection,
          }).then((response) => {
            if (response.status === 500) {
              setPdfV2Status({ ...pdfV2Status, status: 'error' });
            } else {
              pdfId.current = response.data.pdfId;
              setPdfV2Status({ ...pdfV2Status, status: 'pending' });
            }
          });
        }
      } else {
        if (nonStewardshipItems.length > 0 && nonStewardshipItems[0].to.includes('print_new=1')) {
          pdfstatus = await getPDF({
            pdfTitle: title.replaceAll('System (', 'System-('),
            pdfListItems: nonStewardshipItems,
            cancelToken: cancelToken.signal,
            signal,
            setConfirmPDFTitle,
          });
        } else {
          pdfstatus = await getPDFOld({
            pdfTitle: title.replaceAll('System (', 'System-('),
            pdfListItems: nonStewardshipItems,
            cancelToken: cancelToken.signal,
            signal,
            setConfirmPDFTitle,
          });
        }
      }

      if (onlyV2Requested) {
        return;
      }

      if (pdfstatus === undefined) {
        handlePDFDownloadLoader(false);
        handlePDFDownloadNotification(false);
      } else if (pdfstatus.pdfstatus && pdfstatus.error === '') {
        await handleGeneratePDF({
          pdfstatus: pdfstatus.pdfstatus,
          pdffileURL: pdfstatus.pdffileURL,
          error: pdfstatus.error,
        });
        handlePDFDownloadLoader(false);
        handlePDFDownloadNotification(true);
        handlePDFDownloadCancelClick(false);
      } else if (pdfstatus.pdfstatus && pdfstatus.error !== '' && pdfstatus.pdfstatus !== '') {
        await handleGeneratePDF({
          pdfstatus: pdfstatus.pdfstatus,
          pdffileURL: pdfstatus.pdffileURL,
          error: pdfstatus.error,
        });
        handlePDFDownloadLoader(false);
        handlePDFDownloadNotification(true);
        handlePDFDownloadCancelClick(false);
      } else if (!pdfstatus.pdfstatus && pdfstatus.error !== '') {
        await handleGeneratePDF({
          pdfstatus: pdfstatus.pdfstatus,
          pdffileURL: pdfstatus.pdffileURL,
          error: pdfstatus.error,
        });
        handlePDFDownloadLoader(false);
        handlePDFDownloadNotification(true);
        handlePDFDownloadCancelClick(false);
      } else {
        handlePDFDownloadLoader(false);
        handlePDFDownloadNotification(false);
        handlePDFDownloadCancelClick(true);
      }
    }

    if (pdfDownloadLoader) {
      handleResetpdfDownloadStartNotification();
      htmlToPdfFn();
    }
    return function cleanup() {
      cancelToken.abort();
      abortController.abort();
    };
  }, [pdfDownloadLoader, handleGeneratePDF, generatePDF.pdfstatus, pdfDownloadCancelBtn]);

  // Notification
  useEffect(() => {
    const abortController = new AbortController();
    if (pdfDownloadNotification) {
      handleResetpdfDownloadStartNotification();
      generatePDFNotification();
    }
    return function cleanup() {
      abortController.abort();
    };
  }, [pdfDownloadNotification]);
  useEffect(() => {
    const abortController = new AbortController();
    if (pdfDownloadStartNotification) {
      generatePDFDownloadStartNotification();
    }
    return function cleanup() {
      abortController.abort();
    };
  }, [pdfDownloadStartNotification]);

  useEffect(() => {
    const abortController = new AbortController();
    if (notificationDataPopup.length) {
      notificationAlert();
    }
    return function cleanup() {
      abortController.abort();
    };
  }, [notificationDataPopup.length, notificationDataPopup]);

  function ResetPDF_AfterGeneratePDF() {
    handlePDFDownloadNotification(false);
    handlePDFDownloadCancelClick(false);
    handlePDFDownloadLoader(false);
    handleGeneratePDF({
      pdfstatus: false,
      pdffileURL: '',
      error: '',
    });
  }
  function generatePDFNotification() {
    const notification = notificationSystem.current;
    if (notification !== null && generatePDF.error === '') {
      notification.addNotification({
        level: 'info',
        position: 'br',
        autoDismiss: null,
        dismissible: true,
        onRemove: function removed() {
          ResetPDF_AfterGeneratePDF();
        },
        children: (
          <div className="pdfBorder">
            <div className="notifications-wrapper fadeInAnimation">
              <div className="notifications-{position}">
                <div
                  className="alert-notificaitons"
                  onClick={async (e) => {
                    e.preventDefault();
                    if (generatePDF.pdffileURL !== '') {
                      window.open(generatePDF.pdffileURL);
                    }
                    ResetPDF_AfterGeneratePDF();
                  }}
                >
                  <div className="alert-notification-title">
                    <span className="">
                      <b>
                        PDF complete :&quot;{confirmPDFTitle || title}&quot; <br />
                      </b>
                    </span>
                  </div>
                  <div className="d-flex align-items-center pdf-notify-link ">
                    <div>
                      Click&nbsp;
                      <span
                        className="text-white link-alert"
                        rel="noopener noreferrer"
                        // onClick={async (e) => {
                        //   e.preventDefault();
                        //   if (generatePDF.pdffileURL !== '') {
                        //     window.open(generatePDF.pdffileURL);
                        //   }
                        //   ResetPDF_AfterGeneratePDF();
                        // }}
                      >
                        <u>here</u>
                      </span>
                      &nbsp; to download.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ),
      });
    } else if (notification !== null && generatePDF.error !== '' && generatePDF.pdffileURL === '') {
      if (generatePDF.error && generatePDF.error.length > 0) {
        generatePDF?.error?.map((i) => {
          notification.addNotification({
            level: 'error',
            position: 'br',
            autoDismiss: null,
            dismissible: true,
            onRemove: function removed() {
              ResetPDF_AfterGeneratePDF();
            },
            children: (
              <>
                <div className="notifications-wrapper fadeInAnimation">
                  <div className="notifications-{position}">
                    <div className="alert-notificaitons">
                      <div className="alert-notification-title">
                        <span className="">
                          <b>
                            PDF Error : There was an issue on Page {i} <br />
                          </b>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="notification-progressBar error" />
              </>
            ),
          });
        });
      } else {
        notification.addNotification({
          level: 'error',
          position: 'br',
          dismissible: true,
          onRemove: function removed() {
            ResetPDF_AfterGeneratePDF();
          },
          children: (
            <>
              <div className="notifications-wrapper fadeInAnimation">
                <div className="notifications-{position}">
                  <div className="alert-notificaitons">
                    <div className="alert-notification-title">
                      <span className="">
                        <b>
                          PDF Error : {generatePDF.error} <br />
                        </b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="notification-progressBar error" />
            </>
          ),
        });
      }
    }
    if (notification !== null && generatePDF.error !== '' && generatePDF.pdffileURL !== '') {
      notification.addNotification({
        level: 'info',
        position: 'br',
        autoDismiss: null,
        dismissible: true,
        onRemove: function removed() {
          ResetPDF_AfterGeneratePDF();
        },
        children: (
          <div className="pdfBorder">
            <div className="notifications-wrapper fadeInAnimation">
              <div className="notifications-{position}">
                <div
                  className="alert-notificaitons"
                  onClick={async (e) => {
                    e.preventDefault();
                    if (generatePDF.pdffileURL !== '') {
                      window.open(generatePDF.pdffileURL);
                      e.preventDefault();
                    }
                    ResetPDF_AfterGeneratePDF();
                  }}
                >
                  <div className="alert-notification-title">
                    <span className="">
                      <b>
                        PDF complete :&quot;{confirmPDFTitle || title}&quot; <br />
                      </b>
                    </span>
                  </div>
                  <div className="d-flex align-items-center pdf-notify-link ">
                    <div>
                      Click&nbsp;
                      <span
                        className="text-white link-alert"
                        rel="noopener noreferrer"
                        // onClick={async (e) => {
                        //   e.preventDefault();
                        //   if (generatePDF.pdffileURL !== '') {
                        //     window.open(generatePDF.pdffileURL);
                        //   }
                        //   ResetPDF_AfterGeneratePDF();
                        // }}
                      >
                        <u>here</u>
                      </span>
                      &nbsp; to download.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ),
      });
      generatePDF.error &&
        generatePDF.error.length > 0 &&
        generatePDF?.error?.map((i) => {
          notification.addNotification({
            level: 'error',
            position: 'br',
            autoDismiss: null,
            dismissible: true,
            onRemove: function removed() {
              ResetPDF_AfterGeneratePDF();
            },
            children: (
              <>
                <div className="notifications-wrapper fadeInAnimation">
                  <div className="notifications-{position}">
                    <div className="alert-notificaitons">
                      <div className="alert-notification-title">
                        <span className="">
                          <b>
                            PDF Error : There was an issue on Page {i} <br />
                          </b>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="notification-progressBar error" />
              </>
            ),
          });
        });
    }
    if (generatePDF.error === '') {
      if (pdfListItems !== undefined) {
        let arrayOfModule = [];
        const splitText = window.origin;
        arrayOfModule = pdfListItems
          .filter((item) => (item.checked ? item.module : ''))
          ?.map((item) => item.to.split(`${splitText}/`)[1].split('?')[0])
          .filter((v, i, a) => a.indexOf(v) === i);
        arrayOfModule.forEach((element) => {
          handleVisitorLog(`/${element}/PDF_Download`, window.location.search);
        });
      }
    }
  }
  function notificationAlert() {
    const alertNotification = notificationSystem.current;
    if (alertNotification !== null) {
      notificationDataPopup?.map((itemN, i) => {
        const item = itemN;
        return setTimeout(() => {
          alertNotification.addNotification({
            level: 'info',
            position: 'br',
            autoDismiss: 10,
            dismissible: true,
            onAdd: function move() {
              const elem = document.getElementsByClassName('notification-progressBar');
              let width = 100;
              const id = setInterval(frame, 100);
              function frame() {
                if (width <= 0) {
                  clearInterval(id);
                } else {
                  width -= 1;
                  Object.keys(elem).forEach((items) => {
                    if (elem[items].id === `${item.alert_inbox_id}`) {
                      elem[items].style.width = `${width}%`;
                    }
                  });
                }
              }
            },
            children: (
              <>
                <div className="notifications-wrapper fadeInAnimation">
                  <div className="notifications-{position}">
                    <div className="alert-notificaitons">
                      <p className="alert-notification-title m-0">
                        {item.alert_option_id === 1 ||
                        item.alert_option_id === 3 ||
                        item.alert_option_id === 14 ||
                        item.alert_option_id === 19 ? (
                          <>
                            <span className="">
                              <b>{item.type.toUpperCase()}:</b>
                              {item.info}
                            </span>
                          </>
                        ) : (
                          <span className="">
                            <b>{item.type.toUpperCase()}:</b>
                          </span>
                        )}
                        <span>
                          {item.filing_type !== null && item.filing_type !== undefined && (
                            <>
                              <b>Type:</b> {item.filing_type}
                            </>
                          )}
                        </span>
                        <span>
                          {item.Company_name !== null && item.Company_name !== undefined && (
                            <>
                              <b>Company: </b> {item.Company_name}
                            </>
                          )}
                        </span>
                        <span>
                          {item.investor_name !== null &&
                            item.investor_name !== undefined &&
                            item.element_type_id !== undefined &&
                            item.element_type_id === 41 && (
                              <>
                                <b>Short seller:</b> {item.investor_name}
                              </>
                            )}
                          {item.investor_name !== null &&
                            item.investor_name !== undefined &&
                            (item.element_type_id === undefined || item.element_type_id !== 41) && (
                              <>
                                <b>Investor:</b> {item.investor_name}
                              </>
                            )}
                        </span>
                        <span>
                          {item.meeting_date !== null && item.meeting_date !== undefined && (
                            <p>
                              <b>Meeting Date:</b>
                              {dateToNull(item.meeting_date, 'dd-mmm-yyyy', true)}
                            </p>
                          )}
                        </span>
                        <span>
                          {item.alert_name !== null && item.alert_name !== undefined ? (
                            item.element_type_id === 151 ||
                            item.element_type_id === 152 ||
                            item.element_type_id === 161 ||
                            item.element_type_id === 162 ||
                            item.element_type_id === 171 ||
                            item.element_type_id === 172 ||
                            item.element_type_id === 173 ||
                            item.element_type_id === 61 ||
                            item.element_type_id === 62 ||
                            item.element_type_id === 51 ? (
                              <>
                                <b>Alert Name:</b> {item.alert_name}
                              </>
                            ) : (
                              ''
                            )
                          ) : (
                            ''
                          )}
                        </span>
                        <span>
                          {item.investor_profile_name !== null && item.investor_profile_name !== undefined && (
                            <>
                              <b>Investor Profile Name: </b>
                              {item.investor_profile_name}
                            </>
                          )}
                        </span>
                      </p>
                      <div className="d-flex align-items-center alert-notify-link">
                        <div>
                          Click&nbsp;
                          <span
                            className="text-white link-alert"
                            rel="noopener noreferrer"
                            onClick={async (e) => {
                              await updateAlertStatusReq(item.alert_inbox_id);
                              await handleOnClickNotification({
                                alert_inbox_id: item.alert_inbox_id,
                              });
                              await getElementDetailReq({
                                element_type_id: item.element_type_id,
                                alert_inbox_id: item.alert_inbox_id,
                                alert_data: item,
                              });
                              await getInboxAlertByUserReq({
                                alert_id: item.alert_id,
                                alert_inbox_id: item.alert_inbox_id,
                              });
                              history.push(MY_ALERT_INBOX);
                              e.preventDefault();
                            }}
                          >
                            <u>here</u>
                          </span>
                          &nbsp; to view.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="notification-progressBar" id={item.alert_inbox_id} />
              </>
            ),
          });
        }, 500 * i);
      });
    }
  }
  function generatePDFDownloadStartNotification() {
    const alertNotification = notificationSystem.current;
    if (alertNotification !== null) {
      alertNotification.addNotification({
        level: 'info',
        position: 'br',
        autoDismiss: 10,
        dismissible: true,
        children: (
          <>
            <div className="notifications-wrapper fadeInAnimation">
              <div className="notifications-{position}">
                <div className="alert-notificaitons">
                  <p className="alert-notification-title m-0">PDF Download Started</p>
                </div>
              </div>
            </div>
          </>
        ),
      });
    }
  }
  // #endregion
  return (
    <>
      {!query.print ? (
        <div className="px-2 titleSection mainTitleBar">
          {title !== '' && (
            <>
              <div className={bem.e('')}>
                <div className="row px-1 mt-2 mb-2">
                  {title === InvestorTitle &&
                    typeof company_logo !== 'object' &&
                    company_logo !== null &&
                    company_logo !== 'null' &&
                    company_logo !== '' && (
                      <div className="col-1 d-flex justify-content-center titleComponentLogo">
                        <img
                          src={`${COMPANY_LOGO_PATH}${company_logo}`}
                          style={{
                            height: '80px',
                            width: '100px',
                            overflow: 'visible',
                            objectFit: 'contain',
                          }}
                          alt="icon"
                        />
                      </div>
                    )}

                  <div className="col-11">
                    <div className="row">
                      <div className="col-12">
                        {title && typeof title === 'string' ? (
                          <div className={bem.e('title')} style={{ margin: !company_logo && '0px' }}>
                            {title}
                          </div>
                        ) : (
                          title
                        )}
                      </div>
                      <div className="col-12">
                        {title !== '' && breadcrumbs && (
                          <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                              <li className="breadcrumb-item">
                                <a
                                  href={pathConst.DASHBOARD}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    history.replace(pathConst.DASHBOARD);
                                  }}
                                >
                                  Home
                                </a>
                              </li>
                              {breadcrumbs?.length &&
                                breadcrumbs?.map(({ name, active, isLink, url }, index) =>
                                  isLink ? (
                                    <li
                                      className="breadcrumb-item active"
                                      key={`breadcrumb_${index + 1}`}
                                      aria-current="page"
                                    >
                                      <a
                                        href="/"
                                        rel="noopener noreferrer"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          history.replace(url);
                                          xScrollIntoView(name);
                                        }}
                                      >
                                        {name}
                                      </a>
                                    </li>
                                  ) : (
                                    <li
                                      className="breadcrumb-item active"
                                      key={`breadcrumbactive_${index + 2}`}
                                      aria-current="page"
                                    >
                                      {name}
                                    </li>
                                  ),
                                )}
                            </ol>
                          </nav>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {headers}
            </>
          )}
          <div className="alert-notify pdfNotification">
            <NotificationSystem ref={notificationSystem} style={ALERT_NOTIFICATION_SYSTEM_STYLE} />
          </div>
          {notificationDataPopup.length > 0 && (
            <div className="alert-notify">
              <NotificationSystem ref={notificationSystem} style={ALERT_NOTIFICATION_SYSTEM_STYLE} />
            </div>
          )}
        </div>
      ) : (
        <>
          {window.location.pathname === COMPANY_OVERVIEW && (
            <div className="px-2 titleSection mainTitleBarPDF" style={{ margin: !company_logo && '0px' }}>
              {title !== '' && (
                <>
                  <div className={bem.e('')}>
                    <div className="row px-1 mt-2 mb-2">
                      {title === InvestorTitle && (
                        <div
                          className="d-flex"
                          style={{ margin: !company_logo && '0px', padding: !company_logo && '0px' }}
                        >
                          {company_logo && (
                            <img
                              src={`${COMPANY_LOGO_PATH}${company_logo}`}
                              style={{
                                height: '64px',
                                width: '64px',
                                overflow: 'visible',
                                objectFit: 'contain',
                              }}
                              alt="icon"
                            />
                          )}
                          {title && typeof title === 'string' ? (
                            <div className={bem.e('title')} style={{ margin: !company_logo && '0px' }}>
                              {title}
                            </div>
                          ) : (
                            title
                          )}
                        </div>
                      )}

                      {/* <div className='col-11'>
                    <div className='row'>
                      <div className='col-12'>
                        {title && typeof title === 'string' ? (
                          <h1 className={bem.e('title')}>{title}</h1>
                        ) : (
                          title
                        )}
                      </div>
                    </div>
                  </div> */}
                    </div>
                  </div>
                </>
              )}
              <div className="alert-notify pdfNotification">
                <NotificationSystem ref={notificationSystem} style={ALERT_NOTIFICATION_SYSTEM_STYLE} />
              </div>
              {notificationDataPopup.length > 0 && (
                <div className="alert-notify">
                  <NotificationSystem ref={notificationSystem} style={ALERT_NOTIFICATION_SYSTEM_STYLE} />
                </div>
              )}
            </div>
          )}
        </>
      )}
      {middleContentComponent}
    </>
  );
};

TitleComponent.propTypes = {
  breadcrumbs: PropTypes.array,
  handlePDFDownloadNotification: PropTypes.func,
  handleGeneratePDF: PropTypes.func,
  handleVisitorLog: PropTypes.func,
  headers: PropTypes.any,
  pdfDownloadNotification: PropTypes.any.isRequired,
  handlePDFDownloadLoader: PropTypes.func,
  generatePDF: PropTypes.object.isRequired,
  pdfDownloadLoader: PropTypes.bool.isRequired,
  pdfListItems: PropTypes.array,
  title: PropTypes.any,
  company_logo: PropTypes.any,
};

export default React.memo(TitleComponent);
